'use client'

import Breadcrumb from '@/components/breadcrumb'
import LinkAbout from '@/components/links/about'
import { getTeamsHref } from '@/components/links/about/teams'
import { TeamFilter } from '@/entities/teams'
import { parseQuery } from '@/lib/fetch/team'
import TeamsRoute from '@/lib/routes/teams'
import { toSlug } from '@/lib/url'
import { map } from 'lodash-es'
import { useRouter } from 'next/navigation'
import { useRef } from 'react'

export function TeamsFilterContent({
  data,
  query,
}: {
  data: TeamFilter
  query?: string
}) {
  const { locationOptions, departmentOptions } = getOptions(data)
  const { location, department } = parseQuery(query)

  const formRef = useRef<HTMLFormElement>(null)
  const router = useRouter()
  function handlerFormSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const locationValue = formData.get('location') as string
    const departmentValue = formData.get('department') as string
    const route = new TeamsRoute()

    const location = locationOptions.find(
      (item) => item.value === locationValue
    )
    const department = departmentOptions.find(
      (item) => item.value === departmentValue
    )

    if (location) {
      route.setVal('location', toSlug(location.label, location.value))
    }
    if (department) {
      route.setVal('department', toSlug(department.label, department.value))
    }
    router.replace(getTeamsHref(route.getSlug()), {
      scroll: false,
    })
  }
  function filterChange() {
    formRef.current?.requestSubmit()
  }

  return (
    <section className='p-4 lg:py-0 lg:h-17.5 border-b border-secondary/20 lg:px-7.5 flex flex-col gap-y-3 lg:flex-row lg:items-center lg:justify-between'>
      <Breadcrumb home items={[<LinkAbout key='about'>About</LinkAbout>]}>
        Teams
      </Breadcrumb>
      <form
        className='flex gap-x-2.5 items-center'
        onSubmit={handlerFormSubmit}
        ref={formRef}
      >
        <span>Location</span>
        <select
          className='flex-1 lg:w-55 h-8 border border-secondary/30 rounded-sm'
          name='location'
          onChange={filterChange}
          defaultValue={location || ''}
        >
          <option value=''>All</option>
          {locationOptions.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <span className='sm:ml-7.5 lg:ml-12.5'>Department</span>
        <select
          className='flex-1 lg:w-55 h-8 border border-secondary/30 rounded-sm'
          name='department'
          onChange={filterChange}
          defaultValue={department || ''}
        >
          <option value=''>All</option>
          {departmentOptions.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </form>
    </section>
  )
}

function getOptions(data: TeamFilter) {
  const locationOptions = map(data.location, (value, key) => ({
    label: value,
    value: key,
  }))
  const departmentOptions = map(data.department, (value, key) => ({
    label: value,
    value: key,
  }))
  return { locationOptions, departmentOptions }
}
